import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "main"
};
const _hoisted_4 = {
  class: "login-wrap"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Contract authorization analysis", -1);
const _hoisted_6 = {
  class: "option"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Review the Approvals state of wallet, including Tokens and NFTs. Risky Approvals can be Revoked or adjusted", -1);
import MyHeader from '../components/MyHeader';
import { onMounted, ref, watch } from 'vue';
import chains from '../assets/json/chains';
import showErrorMessage from '@/assets/js/error';
import { useRouter } from 'vue-router';
export default {
  __name: 'HomeViewNew',
  setup(__props) {
    const router = useRouter();
    const regex = /^0x[a-fA-F0-9]{40}$/;
    const chain = ref('eth');
    const address = ref('');
    const options = JSON.parse(JSON.stringify(chains));
    // {
    //   eth: { chainId: 1, name: 'Ethereum', icon: require('../assets/images/chain-eth.svg') },
    //   bsc: { chainId: 56, name: 'BNB Chain', icon: require('../assets/images/chain-bnb.svg') },
    //   polygonscan: { chainId: 137, name: 'Polygon', icon: require('../assets/images/chain-polygon.svg') },
    //   ftmscan: { chainId: 250, name: 'Fantom', icon: require('../assets/images/chain-ftmscan.svg') },
    //   // arbiscan: { chainId: 42161, name: 'Arbitrum', rpc: 'https://arbitrum-mainnet.infura.io/', icon: require('@/assets/images/i-arbiscan-l.png'), iconh: require('@/assets/images/i-arbiscan-l.png'), json: require(`@/assets/json/data-arbiscan.json`) },
    //   // snowtrace: { chainId: 43114, name: 'Avalanche', rpc: 'https://api.avax.network/ext/bc/C/rpc/', icon: require('@/assets/images/i-snowtrace-l.png'), iconh: require('@/assets/images/i-snowtrace-l.png'), json: require(`@/assets/json/data-snowtrace.json`) },
    //   // optimism: { chainId: 10, name: 'Optimism', rpc: 'https://optimism-mainnet.infura.io/', icon: require('@/assets/images/i-optimism-l.png'), iconh: require('@/assets/images/i-optimism-l.png'), json: require(`@/assets/json/data-optimism.json`) },
    //   // cronoscan: { chainId: 25, name: 'Cronos', rpc: 'https://evm.cronos.org/', icon: require('@/assets/images/i-cronoscan-l.png'), iconh: require('@/assets/images/i-cronoscan-l.png'), json: require(`@/assets/json/data-cronoscan.json`) },
    // }

    const handleSearch = () => {
      address.value = address.value.trim();
      if (!regex.test(address.value.trim())) {
        showErrorMessage('Not a valid address');
        return;
      }
      router.push(`/tokenapproval/${chain.value}/${address.value}`);
    };
    onMounted(() => {
      document.querySelector('.login-wrap .el-input__inner').classList.add('bg');
      document.querySelector('.login-wrap .el-input__inner').style.backgroundImage = `url(${options[chain.value].icon})`;
    });
    watch(() => chain.value, newValue => {
      document.querySelector('.login-wrap .el-input__inner').style.backgroundImage = `url(${options[newValue].icon})`;
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(MyHeader)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_select, {
        modelValue: chain.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => chain.value = $event),
        class: "m-2",
        placeholder: "Select",
        size: "large",
        style: {
          "width": "100%",
          "height": "56px",
          "margin-bottom": "20px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (item, key) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.chainId,
            label: item.name,
            value: key
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
              src: item.icon,
              alt: ""
            }, null, 8, _hoisted_7), _createTextVNode(" " + _toDisplayString(item.name), 1)])]),
            _: 2
          }, 1032, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: address.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => address.value = $event),
        onKeyup: _withKeys(handleSearch, ["enter"]),
        clearable: true,
        class: "w-50 m-2",
        size: "large",
        placeholder: "Input a wallet address to check the Approval status.",
        style: {
          "width": "100%",
          "margin-bottom": "20px"
        }
      }, null, 8, ["modelValue", "onKeyup"]), _createElementVNode("button", {
        class: "success",
        disabled: address.value.length <= 5,
        onClick: handleSearch
      }, "Check", 8, _hoisted_8), _hoisted_9])])])]);
    };
  }
};